import Link from 'next/link';
import React from 'react';

export default function LocationsList({ locations, position = 'down', toggleMenu, title = 'Service Areas', link=true }) {
  return (
    <ul className="flex flex-wrap items-center space-x-6 w-full justify-between">
      <li className="relative group w-full">
        <div className='hover:text-brand  w-full transition  border-brandLight rounded-full uppercase font-semibold text-base text-white lg:text-brandGray flex'>
        {link? (

          <Link
            href={`/service-area`}
            className=""
            onClick={toggleMenu}
          >
            <span>{title}</span>
          </Link>
        ): (
          <span>{title}</span>

        )}
          {/* Arrow indicating dropdown */}
          <svg
            aria-hidden="true"
            className={position == 'up' ? 'flex-1 mx-2 rotate-180' : "kadence-svg-icon kadence-arrow-down-svg flex-1 mx-2"}
            fill="currentColor"
            version="1.1"
            xmlns="https://www..w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
          >
            <span>Expand</span>
            <path d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
          </svg>
        </div>
        {/* Dropdown with location items */}
        <ul
          className={`absolute ${position === 'up' ? 'bottom-full' : 'top-full'
            } lg:left-0 hidden group-hover:block bg-[#262827] shadow-lg overflow-hidden z-50 min-w-64 max-h-72 overflow-y-auto`}
          
        >
          {locations.map((state) => (
            <React.Fragment key={state.state_slug}>
              <li>
                <Link
                  href={`#`}
                  className="block px-4 py-1 font-bold hover:bg-black uppercase text-gray-100"
                >
                  {state.state}
                </Link>
              </li>
              {state.locations.map((location) => (
                <li className="" key={location.slug}>
                  <Link
                    href={`/service-area/${state.state_slug}/${location.slug}`}
                    className="block px-4 py-1 hover:bg-black text-gray-100 pl-8"
                  >
                    {location.title}
                  </Link>
                </li>
              ))}
            </React.Fragment>
          ))}
        </ul>
      </li>
    </ul>
  );
}

// import { fetchAPI } from '@/lib/api';
// import Link from 'next/link';
// import React from 'react';



// export default function LocationsList({locations}) {
//   // const [stateLocations, setStateLocations] = useState([]);

//   // Fetch locations data on component mount
// //   useEffect(() => {

// //     console.log("Fetching locations data...", locations);
// // }, []);

//   return (
//     <ul className="flex flex-wrap items-center space-x-6 w-full justify-between">
//         <li  className="relative group">
//           <Link
//             href={`/pooper-scooper-service-area-locations`}
//             className="hover:text-brand px-5 transition border border-brandLight rounded-full uppercase font-semibold text-base text-brandGray flex"
//           >
//             <span>Locations</span>
//             {/* Show arrow if locations exist */}
//               <svg
//                 aria-hidden="true"
//                 className="kadence-svg-icon kadence-arrow-down-svg"
//                 fill="currentColor"
//                 version="1.1"
//                 xmlns="https://www..w3.org/2000/svg"
//                 width="20"
//                 height="20"
//                 viewBox="0 0 20 20"
//               >
//                 <span>Expand</span>
//                 <path d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
//               </svg>
//           </Link>

//           {/* Dropdown with location items */}
//             <ul className="absolute left-0 top-full hidden divide-y divide-brandGray group-hover:block bg-[#262827] shadow-lg w-full overflow-hidden z-10 min-w-64 h-72 overflow-y-auto">
//       {locations.map((state) => (
//         <React.Fragment key={state.state_slug}>
//             <li key={state.state_slug}>
//             <Link
//                     href={`#`}
//                     className="block px-4 py-1  font-bold hover:bg-black uppercase text-gray-100"
//                   >{state.state}</Link>
//             </li>
//               {state.locations.map((location) => (
//                 <li className='' key={location.slug}>
//                   <Link
//                     href={`/service-area/${state.state_slug}/${location.slug}`}
//                     className="block px-4 py-1  hover:bg-black  text-gray-100 pl-8"
//                   >
//                     {location.title}
//                   </Link>
//                 </li>
//               ))}
//               </React.Fragment>
//           ))}
//             </ul>
//         </li>

//     </ul>
//   );
// }
